const func = (existing, subs) => {
  for (var i = 0; i < subs.length; i++) {
    const sub = subs[i]
    if (existing[sub.attributes.url] === undefined) {
      existing[sub.attributes.url] = []
    }
    existing[sub.attributes.url].push(sub)
  }
  return existing
}

export default func
